export default __webpack_public_path__ + "static/media/02_DAIF_Services_04_loop.43ed5614.mp4";